import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";
import { crestBorderRadius } from "../sharedStyles.css";

export const crestImgStyles = style({
  display: "block",
  borderRadius: crestBorderRadius,
  maxWidth: "none",
});

const iconBaseStyles = style({
  display: "block",
});

export const iconBlank = style([
  iconBaseStyles,
  {
    fill: vars.colors.onSurfaceOpacityHigh,
  },
]);

export const iconInteractive = style([
  iconBaseStyles,
  {
    fill: "currentColor",
  },
]);
